module.exports = __webpack_public_path__ + "static/media/blue-background.8b1ccc91.svg";